import React, { useEffect, useState } from "react";
import Actions from "../../../actions";
import { connect } from "react-redux";
import { clickToLinkHandler } from "../../../helpers/utils";
import { isEmpty } from "lodash";
import ProgressBar from "../progressBar";
import C from "../../../constants";

const Helpers = (props) => {
  const { meta, time, createDocument } = props;

  const [remainingTime, setRemainingTime] = useState();

  const getLinkToGeneratedDocument = (
    userId,
    documentId,
    dealsObject = null
  ) => {
    return (
      "/" +
      userId +
      "/documents/" +
      documentId +
      "/document-preview/" +
      (dealsObject && dealsObject.is_deals ? dealsObject.deal_id : "0") +
      "/version/0"
    );
  };

  useEffect(() => {
    if (!isEmpty(meta) && meta.title && meta.title === "create document") {
      setRemainingTime(time);

      createDocument(
        meta.obj.templates,
        meta.obj.variables,
        meta.obj.dealsObject,
        (documents) => {
          documents.forEach((d) => {
            d.newClients.forEach((client) => {
              window.store.dispatch({
                type: C.CLIENT_CREATE_SUCCESS,
                result: client,
              });
            });
          });

          setRemainingTime();

          clickToLinkHandler(
            getLinkToGeneratedDocument(
              meta.obj.user.id,
              documents[0].document.id,
              meta.obj.dealsObject
            )
          );
        },
        false,
        ""
      );
    }
  }, [meta, time]);

  return <ProgressBar progressBarTime={remainingTime} />;
};

const mapStateToProps = (state) => {
  const { meta, time } = state.progress;

  return {
    meta,
    time,
  };
};

const mapDispatchToProps = (dispatch) => ({
  createDocument: function (templates, variables, dealsObject, callback) {
    dispatch(
      Actions.createDocument(templates, variables, dealsObject, callback)
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Helpers);
